import React, { useState } from 'react';
import { Button } from '../components/Button';
import { Bug } from 'lucide-react';
interface WelcomeScreenProps {
  onNavigate: (screen: 'login' | 'signup' | 'forgot-password' | 'reset-email-sent' | 'create-new-password' | 'reset-link-expired' | 'password-reset-success') => void;
}
export function WelcomeScreen({
  onNavigate
}: WelcomeScreenProps) {
  const [showDebug, setShowDebug] = useState(false);
  return <div className="flex flex-col h-full w-full bg-stone-50 relative" data-id="element-1220">
      {/* Debug Toggle */}
      <button onClick={() => setShowDebug(!showDebug)} className="absolute top-8 right-2 z-40 w-7 h-7 rounded-full bg-slate-800/70 text-white flex items-center justify-center hover:bg-slate-800 transition-colors" title="Debug panel" data-id="element-1221">
        <Bug size={14} data-id="element-1222" />
      </button>

      {/* Debug Panel */}
      {showDebug && <div className="absolute top-16 right-2 z-40 bg-slate-800 text-white rounded-2xl p-3 shadow-xl w-64 text-xs animate-in fade-in zoom-in-95 duration-150 max-h-[600px] overflow-y-auto" data-id="element-1223">
          <p className="font-bold text-slate-400 uppercase tracking-wider text-[10px] mb-2" data-id="element-1224">
            Debug Panel
          </p>

          <div className="border-t border-slate-700 pt-2 mt-1 mb-1" data-id="element-1225">
            <p className="font-bold text-slate-400 uppercase tracking-wider text-[10px] mb-2" data-id="element-1226">
              Forgot Password Flow
            </p>
            <button onClick={() => {
          setShowDebug(false);
          onNavigate('forgot-password');
        }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1227">
              ▶ Forgot Password screen
            </button>
            <button onClick={() => {
          setShowDebug(false);
          onNavigate('reset-email-sent');
        }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1228">
              ▶ Reset Email Sent
            </button>
            <button onClick={() => {
          setShowDebug(false);
          onNavigate('create-new-password');
        }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1229">
              ▶ Create New Password
            </button>
            <button onClick={() => {
          setShowDebug(false);
          onNavigate('reset-link-expired');
        }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1230">
              ▶ Link Expired state
            </button>
            <button onClick={() => {
          setShowDebug(false);
          onNavigate('password-reset-success');
        }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium" data-id="element-1231">
              ▶ Password Reset Success
            </button>
          </div>
        </div>}

      {/* Top decorative blob/gradient */}
      <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-emerald-100/50 to-transparent pointer-events-none" data-id="element-1232" />

      {/* Mascot Video Area */}
      <div className="flex-1 flex flex-col items-center justify-center pt-12 px-6 relative z-10" data-id="element-1233">
        <div className="w-64 h-64 md:w-72 md:h-72 relative mb-8" data-id="element-1234">
          <div className="absolute inset-0 bg-emerald-200/20 rounded-full blur-3xl animate-pulse" data-id="element-1235" />
          <video autoPlay loop muted playsInline className="w-full h-full object-cover rounded-[3rem] shadow-xl border-4 border-white" src="https://cdn.magicpatterns.com/uploads/c1Fd9zZMznC91bNY9TY4fk/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_e2530ab6-4d7f-40b4-b7c1-c0e476f35e9b_0.mp4" data-id="element-1236" />
        </div>

        <div className="text-center space-y-3 max-w-xs mx-auto" data-id="element-1237">
          <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight" data-id="element-1238">
            Welcome to <span className="text-emerald-500" data-id="element-1239">GymBuddy</span>
          </h1>
          <p className="text-lg text-slate-500 font-medium leading-relaxed" data-id="element-1240">
            Your personal gym activity tracker. Friendly, simple, and
            supportive.
          </p>
        </div>
      </div>

      {/* Bottom Actions Area */}
      <div className="p-6 pb-10 space-y-4 bg-white/50 backdrop-blur-lg rounded-t-[2.5rem] border-t border-white/80 shadow-[0_-10px_40px_-15px_rgba(0,0,0,0.05)] relative z-10" data-id="element-1241">
        <Button variant="secondary" fullWidth onClick={() => onNavigate('signup')} data-id="element-1242">
          I have no account
        </Button>
        <Button variant="outline" fullWidth onClick={() => onNavigate('login')} data-id="element-1243">
          Login
        </Button>
      </div>
    </div>;
}